import { render, staticRenderFns } from "./mis-casos.vue?vue&type=template&id=023ad476&"
import script from "./mis-casos.vue?vue&type=script&lang=js&"
export * from "./mis-casos.vue?vue&type=script&lang=js&"
import style0 from "./mis-casos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports